export enum ImageUploadStatus {
  Completed = '100% Completed',
  Failed = 'FAILED UPLOAD!',
  Loading = 'Loading',
  Queued = 'Queued',
  ImageRecognitionFailed = 'Failed Recognition',
  None = ''
}